module.exports = __webpack_public_path__ + "img/logo_white.efd374a9.png";